import { createActionsHook } from 'src/lib/sweetState';

import { AudienceTargetingStore } from './AudienceTargetingStore';

export const useAudienceTargetingActions = createActionsHook(AudienceTargetingStore);
